<div class="flx-modal" role="dialog" aria-modal="true" *ngIf="addAssignToForm && translate">
    <!-- header -->
    <div class="flx-modal__header">
        <h2>{{translate?.general.buttons.assign.singular}} {{ translate?.jobOrder.label.singular }}</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()" tooltipPosition="left">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
<form [formGroup]="addAssignToForm" (ngSubmit)="onConfirm()">
    <div class="flx-modal__body mp-body">
        <label class="field-label mandatory">Assign to</label>

        <div class="field-row field-row--auto mb-2">
             <div>
                <p-dropdown placeholder="{{translate?.general.buttons.select2.singular}} Order Owner"
                [options]="assignToOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="assignType"
                [(ngModel)]="assignToData.assignmentType"
                (onChange)="onAssignTypeChange($event)"
                ></p-dropdown>
                <div class="p-error text-10" *ngIf=" addAssignToForm.controls['assignType'].touched && addAssignToForm.controls['assignType'].hasError('required') ">
                    <span *ngIf="addAssignToForm.controls['assignType'].errors?.required" id="label_AssetLocStreetReqField" >{{ translate?.general.validationFE.requiredField }}</span>
                </div>
            </div>

            <div *ngIf="assignToData.assignmentType == 'GROUP' || assignToData.assignmentType == 'USER'">
                <ng-container [ngSwitch]="assignToData.assignmentType">
                    <p-dropdown 
                        *ngSwitchCase="'GROUP'"
                        placeholder="{{translate?.general.buttons.select2.singular}} {{translate?.setup.users.groups.label.singular}}"
                        [options]="usersGroupList"
                        [showClear]="true"
                        optionLabel="name"
                        formControlName="assignTo"
                        [(ngModel)]="assignToData.assignedTo"
                        [filter]="true"
                        ></p-dropdown>

                        <p-dropdown
                        *ngSwitchCase="'USER'"
                        [placeholder]="translate?.general.messages.none"
                        [options]="userList" 
                        [showClear]="true"
                        [(ngModel)]="assignToData.assignedTo" 
                        id="picklist_SetGroDefUserField"
                        name="user" 
                        [filter]="true"
                        optionLabel="fullName"
                        formControlName="assignTo">
                    </p-dropdown>
                </ng-container>

                <div class="p-error text-10" *ngIf=" addAssignToForm.controls['assignTo'].touched && addAssignToForm.controls['assignTo'].hasError('required') ">
                    <span *ngIf="addAssignToForm.controls['assignTo'].errors?.required" id="label_AssetLocStreetReqField" >{{ translate?.general.validationFE.requiredField }}</span>
                </div>
            </div>
        </div>

        <div class="note-no-border">
            <!-- <div class="icon">
                <i class="fa-regular fa-circle-info" aria-hidden="true"></i>
            </div> -->
            <p *ngIf="assignToData.assignmentType == 'CUSTODIAN'">Automatically assign the job to the {{translate?.asset.label.singular}}’s designated custodian.</p>
            <p *ngIf="assignToData.assignmentType == 'USER'">Manually select a single user to assign this job to.</p>
            <p *ngIf="assignToData.assignmentType == 'GROUP'">Assign the job to a user group. Jobs will be distributed to group members in round-robin order, so work is shared fairly among the team.</p>
        </div>
    </div>
</form>
    <!-- footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="onBack()">{{translate?.general.buttons.back.singular}}</button>
        <p-button type="button" icon="fa-regular fa-check" [label]="translate?.general.buttons.confirm.singular" (onClick)="onConfirm()" styleClass="h-32"></p-button>
    </div>
</div>